




import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class VTag extends Vue {
  @Prop() tag!: string;
}
